export const Game = {
  IFRAME_NAME: 'iframe-game',
}
